import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, Music } from "lucide-react";
import api, { formatCount } from "../lib/api";
import { Avatar } from "../components/Avatar";

const Artists = () => {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/artists").then((r) => setArtists(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 pb-24">
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-white">Artists</h1>
      <p className="text-zinc-400 mt-2">The voices defining what's next.</p>

      {loading ? (
        <p className="text-zinc-500 mt-10">Loading…</p>
      ) : (
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {artists.map((a, i) => (
            <Link
              key={a.id}
              to={`/artist/${a.id}`}
              data-testid={`artist-card-${a.id}`}
              className="group relative overflow-hidden border border-white/10 bg-zinc-950 nx-fade-up"
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <div className="aspect-[4/3] overflow-hidden bg-zinc-900">
                <Avatar src={a.avatar} name={a.name} className="w-full h-full transition-transform duration-500 group-hover:scale-105" textClass="text-6xl" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="font-display text-2xl font-bold text-white">{a.name}</h3>
                <p className="text-sm text-zinc-300 line-clamp-1">{a.bio}</p>
                <div className="mt-2 flex items-center gap-4 text-xs text-zinc-400">
                  <span className="flex items-center gap-1"><Users className="h-3 w-3" /> {formatCount(a.followers)} followers</span>
                  <span className="flex items-center gap-1"><Music className="h-3 w-3" /> {a.video_count} videos</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Artists;
